import { lazy } from 'react';
import { RouteConfig } from "../../types/RouteConfig";

export const landingPageRedirectionRoute: RouteConfig<'with-page'> = {
    path: '/',
    name: 'Home Route',
    page: lazy(() => import('.')),
    flags: ['no-menu-item'],
}